import { ParentContext } from 'global/cnr/contexts/ParentContext'
import { uniqueKey } from 'global/common/keys'
import { sortingHelpers, updateArrayInclusion } from 'global/common/sorting'
import MotionDiv from 'global/motions/MotionDiv'
import _ from 'lodash'
import { SportsSeasonContext } from 'projectSpecific/sports/cnr/contexts/SportsSeasonContext'
import { gameScoringTypes } from 'projectSpecific/sports/cnr/reducers/SportsSeasonReducer'
import { CreatePlayoffContext } from 'projectSpecific/sports/create/CreatePlayoff'
import { SectionHeaders } from 'projectSpecific/sports/elements/standings/SectionHeaders'
import { useSportsFilters } from 'projectSpecific/sports/useHelpers/useSportsFilters'
import { useContext } from 'react'
import { Icon, Label, Popup } from 'semantic-ui-react'
import { SportsStandingsContext } from './LeagueStandings'
import { TeamSectionRecord } from './TeamSectionRecord'

export const _standingsViewTypes = {
  full: 'full',
  form: 'form',
  remaining: 'remaining',
  bestWins: 'bestWins',
  worstLosses: 'worstLosses',
  insights: 'insights',
  nonSection: 'nonSection',
  // vs: 'vs',
}

export const SectionStandingz = ({
  levelKey,
  teamKey,
  _teamsFavs,
  forPlayoff,
  caption,
  standingsViewType,
  matchKey,
  matchSections
}) => {

  const parentContext = useContext(ParentContext);
  const { fns, states } = parentContext ?? {}
  const { appUser_state } = states ?? {}
  const { navigation_fns } = fns

  const { appUser } = appUser_state ?? {}
  const { profileData } = appUser ?? {}
  const { favs_info } = profileData ?? {}
  const { eventFavs } = favs_info ?? {};
  const team_favs = eventFavs && eventFavs['teams']

  const sportsSeasonContext = useContext(SportsSeasonContext)
  const { sportsSeason_state, sportsSeason_handlers } = sportsSeasonContext ?? {}
  const { currentSeason_info, teams_info, matches_info, details_info, sportSettings_info, sportsShowType, links_score } = sportsSeason_state ?? {}
  const { teams } = teams_info ?? {}
  const { matches, matches_playoffs, section_info } = matches_info ?? {}
  const { sectionStats } = section_info ?? {}
  const { gameScoringType, gameAllowTies, _sportsModeSport } = currentSeason_info ?? {}
  const { sortStandingsByPoints } = links_score ?? {}

  const teamsByLevel = _.groupBy(teams, 'levels')

  const { showRankingsInStandings } = sportSettings_info ?? {}
  const { playoffTeams: playoffTeams_season } = teams_info ?? {}
  const { sectionPlayoffTeams, playoffQualifyCounts, details } = details_info ?? {}
  const { hideStandingsFilters } = details ?? {}

  const sportsStandingsContext = useContext(SportsStandingsContext)
  const { sportsStandings_state, sportsStandings_handlers } = sportsStandingsContext ?? {}
  const { selected_teams } = sportsStandings_state ?? {}

  const createPlayoffContext = useContext(CreatePlayoffContext);
  const { createPlayoff_handlers } = createPlayoffContext ?? {}

  const { sortSectionStandings } = useSportsFilters()

  const handleSelectedTeams = (team) => {
    const _sts = [...selected_teams]
    updateArrayInclusion(_sts, team._itemKey)
    sportsStandings_handlers.handleSet_selected_teams(_sts)
  }

  const handlePlayoffClick = (e, team) => {
    if (e) { e.cancelBubble = true };
    if (e && e.stopPropagation) e.stopPropagation();

    // createPlayoff_handlers.handleSelect_playoffTeamRecord(team)
    createPlayoff_handlers.handleSelect_playoffTeam(team)
  }

  // const handleSelectClick = (e, team) => {
  //   e.cancelBubble = true;
  //   if (e.stopPropagation) e.stopPropagation();
  //   handleSelectedTeams(team)
  // }

  /**
   * handles the team row click for the standings
   * @param {*} e 
   * @param {*} team 
   */
  const handleTeamClick = (e, team) => {
    if (forPlayoff) {
      handlePlayoffClick(e, team, true)
    } else {
      team && navigation_fns && sportsSeason_handlers.handleGoTo_team(navigation_fns, team)
    }
  }

  const isNonSection = false

  const tableType = 'tst'

  let valueW = 2

  // const motion_wrapper = (content) => <MotionDiv>
  //   {content}
  // </MotionDiv>

  const getSortedTeams = (tmz) => {
    if (sortSectionStandings && tmz) {
      return sortSectionStandings(
        tmz,
        playoffQualifyCounts,
        sectionPlayoffTeams,
        _sportsModeSport,
        forPlayoff,
        false
      );
    }
    return [];
  };

  const standingsHeader = SectionHeaders({ gameScoringType, tableType, isNonSection, gameAllowTies, standingsViewType })

  const standingsTable = (tmz) => {
    if (_.isEmpty(tmz)) { return }
    const sortedTeams = getSortedTeams(tmz)
    const rows = []
    let rowIndex = 0;
    _.forEach(sortedTeams, (team) => {
      const rowKey = 'r' + rowIndex
      rows.push(<TeamSectionRecord
        forPlayoff={forPlayoff}
        handleTeamClick={handleTeamClick}
        isNonSection={isNonSection}
        levelKey={levelKey}
        rowKey={rowKey}
        standingsViewType={standingsViewType}
        tableType={tableType}
        team_favs={team_favs}
        team={team}
        valueW={valueW}
      />)
    })
    return rows
  }

  let cn = 'standings-container'
  let cnt = 'standings-table '

  switch (gameScoringType) {
    case gameScoringTypes.half:
      cnt += ' ties'
      break;
    default:
      cnt += ' no-ties'
      break;
  }

  if (gameScoringType === gameScoringTypes.matchPoints) {
    cnt += ' pts'
  }

  function isFavInSection(tmz, _teamsFavs) {
    let isFav;
    Object.keys(_teamsFavs).forEach(tf => {
      const stf = _.find(tmz, { _itemKey: tf })
      if (stf) { isFav = true }
    })
    return isFav
  }

  const getLevelSections = (lk) => {
    const _team = teamKey ? teams?.[teamKey] : null
    const { sections, levels } = _team ?? {}
    const level_key = teamKey && levels ? levels : lk
    const _levelTeams = teamsByLevel?.[level_key]
    const _sectionTeams = _.groupBy(_levelTeams, 'sections')
    if (matchKey && matchSections) {
      const cs = {}
      _.forEach(matchSections, ms => {
        const _ms = ms.split('-')
        const lev = _ms[0]
        if (lev !== lk) return;
        const sec = _ms[1]
        const _lts = teamsByLevel?.[lev]
        const _sts = _.groupBy(_lts, 'sections')
        cs[sec] = _sts?.[sec]
      })
      return { _levelKey: level_key, currentSections: cs }
    } else if (teamKey) {
      return { _levelKey: level_key, currentSections: { [sections]: _sectionTeams[sections] } }
    } else {
      return { _levelKey: level_key, currentSections: _sectionTeams }
    }
  }

  const popup = (levelKey, trigger, sectionStat, overall) => {
    const { wins, losses, overallMatches, matches, winPct, overallRank, levelRank } = sectionStat ?? {}
    const lbls = []
    lbls.push(<div>{overall ? 'Overall - Non Section Results' : `${levelKey} - Non Section Results`}</div>)
    lbls.push(<Label size='tiny' color={'black'} >{`Matches: ${overallMatches || matches}`}</Label>)
    lbls.push(<Label size='tiny' color={'green'}>{`Wins: ${wins}`}</Label>)
    lbls.push(<Label size='tiny' color={'red'}>{`Losses: ${losses}`}</Label>)
    lbls.push(<Label size='tiny' color={'black'}>{`Win %: ${winPct}`}</Label>)
    levelRank && lbls.push(<Label size='tiny' color={'black'}>{`Level Rank: ${levelRank}`}</Label>)
    overallRank && lbls.push(<Label size='tiny' color={'black'}>{`Overall Rank: ${overallRank}`}</Label>)
    return <Popup
      content={<div style={{ display: 'flex', flexDirection: 'column', gap: '.5em' }}>{lbls}</div>}
      on='click'
      pinned
      position='bottom right'
      basic
      size='tiny'
      style={{ backgroundColor: 'var(--off-black-4)', color: 'white', borderColor: 'var(--off-black-5)', width: '250px' }}
      trigger={trigger}
      flowing
    />
  }

  const levelSectionStandings = () => {

    switch (standingsViewType) {
      default:
        const { currentSections } = getLevelSections(levelKey)
        const _currentSections = sortingHelpers.sortByKey(currentSections)

        const _sectionTables = []

        // loop the section in the level
        _.forEach(_currentSections, (sectionTeams, sectionKey) => {

          const isFavSection = _teamsFavs && isFavInSection(sectionTeams, _teamsFavs)

          const sl = `${levelKey}_${sectionKey}`
          const sectionStat = sectionStats?.[sl] || {}
          const { levelRank, overallRank } = sectionStat

          const lbl_overall = overallRank ? <Label size='tiny' color='black' title={'Overall Rank'}>{overallRank}</Label> : <div></div>
          const lbl_level = overallRank ? <Label size='tiny' color='blue' title={`${levelKey} Rank`}>{levelRank}</Label> : <div></div>

          const secSs = <div className={cn} key={uniqueKey('ss', 'shw', levelKey, sectionKey)}>
            <div key={uniqueKey('ss', 'sh', levelKey, sectionKey)} className={'standings-header'}>
              {isFavSection ? <div><Icon name={'star'} color={'blue'} /></div> : <div></div>}
              <div>{caption || _.startCase(sectionKey)}</div>
              <div>
                {popup(levelKey, lbl_overall, sectionStat, true)}
                {popup(levelKey, lbl_level, sectionStat?.levelMatches?.[levelKey], false)}
              </div>
            </div>
            <div className={cnt}>
              <div className='match-date-matches'>
                <MotionDiv origin='sectionStanding'>
                  <div>{standingsHeader}</div>
                  {standingsTable(sectionTeams, sectionKey)}
                </MotionDiv>
              </div>
            </div>
          </div >

          if (isFavSection) {
            _sectionTables.unshift(secSs)
          } else {
            _sectionTables.push(secSs)
          }
        })
        return _sectionTables
    }

  }

  return <div className='standings-container-legend'>
    <div>
      {levelSectionStandings()}
    </div>
  </div>
}
